import * as React from "react";
import { ViewMe } from "@njoy/controller";
import AntAvatar from "../../../modules/shared/AntAvatar";

interface Props {}

export const HeaderMain: React.FC<Props> = () => {
  return (
    <div className="flex mt-12 flex-col w-full">
      <div className="flex justify-between items-center ">
        <div className="flex gap-2 items-center">
          <ViewMe>
            {(data) => {
              if (!data.match?.customer) {
                return <div className="text-[#9fafb5] flex justify-center items-center h-screen">Loading...</div>;
              }

              return (
                <>
                  <AntAvatar
                    firstname={`${data.match?.customer.firstname}`}
                    lastname={`${data.match?.customer.lastname}`}
                    height="63px"
                    width="63px"
                    fontSize="20px"
                    color="#D9D9D9"
                  />
                  <div className="flex flex-col">
                    <p className="text-[18px] text-white [font-family:'Avenir-Light',Helvetica]">
                      <span>{data.match.customer.firstname} </span>
                      {data.match.customer.lastname}
                    </p>
                    <p className="text-[12px] text-white mt-[-3px] opacity-40">
                      @{data.match.customer.username}
                    </p>
                  </div>
                </>
              );
            }}
          </ViewMe>
        </div>
      </div>
    </div>
  );
};